// Models
/**
 * Enum for SharePlanDialog modes.
 */ export var SharePlanDialogMode = /*#__PURE__*/ function(SharePlanDialogMode) {
    /* To open People tab directly */ SharePlanDialogMode["People"] = "People";
    /* To open Agents tab directly */ SharePlanDialogMode["Agents"] = "Agents";
    /* To open the Meetings tab directly */ SharePlanDialogMode["Meetings"] = "Meetings";
    return SharePlanDialogMode;
}({});
